import React from 'react';
import { Button, Col, Modal, Row } from 'antd';
import { CloseOutlined, EyeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { IBaseFilter, IPlan } from '../../types/plans';
import { IMapController, IMapData } from '../../lib/map';
import Map from '../../components/containers/Map';
import { Filters } from '../../components/Plans/MapListFilters';
import { Plans } from '../../components/Plans/MapList';
import {
  loaderStyle,
  baseEstimateButtonStyle,
  mobilePlansListStyle,
  mobileContainerStyle,
  mobileMapContainerStyle,
  mobileControlsContainerStyle,
  mobilePlansButtonStyle,
  mobileGeocoderClass,
} from './styles';
import { Loader } from '../../components/UI/Loader';

interface MobileMapViewProps {
  refController: React.MutableRefObject<IMapController | null>;
  planView: IPlan | null;
  onChangeMapData: (data: IMapData) => void;
  setLoadMap: (loadMap: boolean) => void;
  loadMap: boolean;
  filters: IBaseFilter;
  setFilters: (filters: IBaseFilter) => void;
  loading: boolean;
  items: IPlan[];
  onPlace: (e: React.MouseEvent<HTMLDivElement>, plan: IPlan) => void;
  onNext: () => void | Promise<void>;
  primaryLabel?: string;
  setOpen?: (open: boolean) => void;
  open?: boolean;
  currentPage: number;
  onPageChange: (page: number) => void;
  totalCount: number;
}

const MobileMapView: React.FC<MobileMapViewProps> = ({
  refController,
  planView,
  onChangeMapData,
  setLoadMap,
  loadMap,
  filters,
  setFilters,
  loading,
  items,
  onPlace,
  onNext,
  primaryLabel,
  setOpen,
  open,
  currentPage,
  onPageChange,
  totalCount,
}) => {
  return (
    <div style={mobileContainerStyle}>
      <div style={mobileMapContainerStyle}>
        <div id="mobile-geocoder" className={mobileGeocoderClass} />
        <Map
          refController={refController}
          plan={planView as IPlan}
          onChange={onChangeMapData}
          onLoad={setLoadMap}
          isMobile={true}
        />
        {loadMap && (
          <div style={loaderStyle}>
            <Loader />
          </div>
        )}
      </div>

      <div style={mobileControlsContainerStyle}>
        <Row gutter={[8, 8]} justify="center">
          <Col span={planView?.id ? 10 : 24}>
            <Button
              disabled={loadMap}
              loading={loadMap}
              style={mobilePlansButtonStyle}
              onClick={() => setOpen?.(true)}>
              <UnorderedListOutlined />
              Plans
            </Button>
          </Col>

          {planView?.id && (
            <Col span={14}>
              <Button
                disabled={loadMap}
                loading={loadMap}
                style={baseEstimateButtonStyle}
                onClick={onNext}>
                <EyeOutlined />
                {primaryLabel || 'Estimate'}
              </Button>
            </Col>
          )}
        </Row>
      </div>

      <Modal
        title="Plans"
        centered
        open={open}
        cancelText="Close"
        onCancel={() => setOpen?.(false)}
        footer={
          <Row gutter={[16, 16]} justify="center">
            {planView?.id && (
              <Col span={22}>
                <Button
                  disabled={loadMap}
                  loading={loadMap}
                  style={{
                    ...baseEstimateButtonStyle,
                    width: '100%',
                    top: '10px',
                    background: '#EE8865',
                  }}
                  onClick={onNext}>
                  <EyeOutlined />
                  {primaryLabel || 'Estimate'}
                </Button>
              </Col>
            )}
            <Col span={22}>
              <Button
                disabled={loadMap}
                loading={loadMap}
                style={{
                  ...baseEstimateButtonStyle,
                  width: '100%',
                  top: '10px',
                }}
                onClick={() => setOpen?.(false)}>
                <CloseOutlined />
                Close
              </Button>
            </Col>
          </Row>
        }
        width={'100%'}>
        <Col
          span={24}
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
          }}>
          <Row justify="space-around" align="stretch">
            <Col span={24}>
              <Filters filters={filters} setFilters={setFilters} />
            </Col>
          </Row>
          <Row justify="space-around" align="stretch" style={mobilePlansListStyle}>
            <Col span={24}>
              {loading ? (
                <Loader styles={{ minHeight: 'calc(100dvh - 210px)', width: 'auto' }} />
              ) : (
                <Plans
                  items={items}
                  onPlace={onPlace}
                  currentPage={currentPage}
                  onPageChange={onPageChange}
                  totalCount={totalCount}
                />
              )}
            </Col>
          </Row>
        </Col>
      </Modal>
    </div>
  );
};

export default MobileMapView;
